import { formatDate } from '../../lib/dateUtils.js';
import MarkdownRenderer from './MarkdownRenderer.jsx';
import styles from './ArticleRenderer.module.css';

/**
 * Renders a single markdown article with a consistent header block:
 * title, author, published date, tags, and rich Markdown body.
 */
export default function ArticleRenderer({ post }) {
  const wasEdited =
    post.lastEditedDate && post.lastEditedDate !== post.publishedDate;

  return (
    <article className={styles.article}>
      <header className={styles.header}>
        <h1>{post.title}</h1>
        <p className={`meta ${styles.byline}`}>
          {post.author} · Published {formatDate(post.publishedDate)}
          {wasEdited && <> · Last edited {formatDate(post.lastEditedDate)}</>}
        </p>
        {post.tags?.length > 0 && (
          <ul className={styles.tags}>
            {post.tags.map((tag) => (
              <li key={tag} className="meta">
                {tag}
              </li>
            ))}
          </ul>
        )}
      </header>
      <div className={styles.body}>
        <MarkdownRenderer content={post.content} baseDir={post.baseDir} />
      </div>
    </article>
  );
}
